import { backendApi } from '../../config'

export const acceptPartnerInviteService = async (token: string, accessToken: string) => {
  const { data } = await backendApi.post(
    `/api/creators/partners/invites/${token}/accept`,
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
  return data
}
